<template>
  <el-form-item
    :id="`price_${country}`"
    class="country-price-form-item"
    :error="validationError || errors[`price_${country}`]"
    :prop="`price_${country}`"
    :rules="{ validator: checkMinCmp }"
  >
    <el-input
      v-model="price"
      :controls="false"
      type="number"
      step="0.01"
      @update:modelValue="input"
      @mousewheel.prevent
    />
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, watch, ref, reactive } from 'vue'
import useValidation from '@/hooks/useValidation'
import { CreativeValidationErrorsKey, ICountryCPM } from '@/api/types'
import { cpmRangeError } from '@/apps/traforama/views/creatives/utils/cpm'

export default defineComponent({
  name: 'CountryPriceInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    country: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    skipCpmCheck: {
      type: Boolean,
      default: false
    },
    validationError: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const price = ref(props.value)
    const invalid = ref(false)
    const { validationErrors } = useValidation(CreativeValidationErrorsKey)
    const errors = validationErrors()

    const checkMinCmp = (
      rule: any,
      _value: any,
      callback: (error?: Error) => void
    ) => {
      if (
        props.skipCpmCheck ||
        price.value === '' ||
        (Number(price.value) >= props.min && Number(price.value) <= props.max)
      ) {
        return callback()
      } else {
        return callback(new Error(cpmRangeError(props.min, props.max)))
      }
    }

    watch(
      (_: any) => props.value,
      (newVal) => {
        price.value = newVal
      }
    )

    function input(newValue: number | string) {
      const newPrice: ICountryCPM = {
        id: props.country,
        value: newValue
      }
      price.value = newValue
      context.emit('update:modelValue', newPrice)
    }
    return { input, price, checkMinCmp, errors }
  }
})
</script>
<style lang="scss" scoped>
.red {
  .el-input__inner {
    background-color: red;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.country-price-form-item :deep(.el-form-item__error) {
  position: static;
  width: 100%;
  white-space: normal;
}
</style>
